import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemRolesUsageRoute: InvariantJiraRoute = {
	name: 'global-settings-system-roles-usage',
	path: '/secure/project/ViewProjectRoleUsage([!%]?[\\w]*).jspa',
};
